import app from './01-mw.app';

const middlewares = [app];
export default middlewares;

